import React, { Component, PropTypes } from 'react';
import {
  Checkbox,
  FlatButton,
} from 'material-ui';
import { path, pathOr, either, not, isNil, isEmpty } from 'ramda';

const isNilOrEmpty = either(isNil, isEmpty);

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seeMoreExpanded: false,
    };
  }

  handleOnCheck = (itemChecked) => {
    const filterItemsSelected = this.props.filterItemsSelected;
    if (this.refs[itemChecked].isChecked()) {
      filterItemsSelected.push(itemChecked);
    } else {
      if (filterItemsSelected.indexOf(itemChecked) !== -1) {
        filterItemsSelected.splice(filterItemsSelected.indexOf(itemChecked), 1);
      } else {
        filterItemsSelected.push(itemChecked);
      }
    }
    this.props.onCheckFunction(this.props.filterNameCamelCase, filterItemsSelected);
  };

  render() {
    const styles = this.props.filterStyles;

    const numberChecked = () => (<span style={{ marginRight: '15px' }}>{path(['filterItemsSelected', 'length'], this.props)} Selected</span>);

    const seeMoreSeeLessExpander = (label) => {
      return (
        <div style={{ textAlign: 'center', marginLeft: '-20px' }}>
          <FlatButton
            label={label}
            labelStyle={{ fontWeight: '600' }}
            secondary
            onTouchTap={() => this.setState({ seeMoreExpanded: !this.state.seeMoreExpanded })}
          />
        </div>
      );
    };

    const nestedCheckboxes = (item, i) => {
      return (
        <Checkbox
          key={i}
          style={styles.checkbox}
          defaultChecked={this.props.filterItemsSelected.indexOf(item) === -1 ? false : true}
          ref={item}
          value={item}
          onCheck={this.handleOnCheck.bind(this, item)}
          label={item}
        />
      );
    };

    return (
      <div style={{ clear: 'both', paddingTop: this.props.filterName === 'Segments' && pathOr(false, ['partnerFinder', 'searchParams', 'companyType'], this.props) === 'Contractor' ? '2%' : '' }}>
        <div
          style={{
            fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif",
            fontSize: '12px',
            color: '#000',
            textTransform: 'uppercase',
            position: 'relative',
            fontWeight: '600',
            margin: '10px 0 0 15px',
          }}
        >
          {this.props.filterName}
        </div>
        <div style={{ marginLeft: '20px' }}>
          {
            this.props.filterList.map((item, index) => index > 2 ? <span key={index} /> : nestedCheckboxes(item, index))
          }
          <div>
            <div style={{ float: 'left', paddingBottom: this.props.filterName === 'Segments' ? '50px' : '' }}>
              {
                path(['filterList', 'length'], this.props) > 2 && !this.state.seeMoreExpanded ? seeMoreSeeLessExpander('+ SEE MORE') : <span/>
              }
            </div>
            <div style={{ float: 'right', marginTop: '8px' }}>
              {
                not(isNilOrEmpty(this.props.filterItemsSelected)) && !this.state.seeMoreExpanded && this.props.filterName !== 'Product Types' ? numberChecked() : <span/>
              }
            </div>
          </div>
          <div>
            {
              this.state.seeMoreExpanded ?
                <div>{this.props.filterList.map((item, i) => i > 2 ? nestedCheckboxes(item, i) : <span key={i} />)}</div> : <span/>
            }
            <div>
              <div style={{ float: 'left', paddingBottom: this.props.filterName === 'Segments' ? '50px' : '' }}>
                {
                  path(['filterList', 'length'], this.props) > 2 && this.state.seeMoreExpanded ? seeMoreSeeLessExpander('- SEE LESS') : <span/>
                }
              </div>
              <div style={{ float: 'right', marginTop: '8px' }}>
                {
                  not(isNilOrEmpty(this.props.filterItemsSelected)) && this.state.seeMoreExpanded && this.props.filterName !== 'Product Types' ? numberChecked() : <span/>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Filter.propTypes = {
  position: PropTypes.string,
  filterName: PropTypes.string,
  iconClassName: PropTypes.string,
  filterList: PropTypes.array,
  filterStyles: PropTypes.object,
  filterItemsSelected: PropTypes.array,
  filterNameCamelCase: PropTypes.string,
  onCheckFunction: PropTypes.func,
};

export default Filter;



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/filter-partnerFinder.jsx